<app-property-form
  [isSearch]="true"
  [formGroup]="formGroup"
  [isLoaded]="true"
  [categories]="categories"
  [locations]="locations"
  [areas]="areas"
></app-property-form>
